/**
 * Quién puede quedar como responsable de una herramienta (A-04).
 *
 * El catálogo de usuarios ofrecía a gente que solo tiene RH y que después no
 * puede aprobar la asignación desde la app: se le asignaba una herramienta a
 * alguien que nunca iba a poder recibirla. El filtro lo hace el servidor con
 * `?moduleKey=`; aquí solo vive la clave y el caso del que ya la tiene.
 */

/** La clave del módulo de Almacén, tal como está en la tabla `modules`. */
export const MODULO_ALMACEN = 'mod_almacen'

/** El catálogo de responsables, ya filtrado por el servidor. */
export const RUTA_DE_RESPONSABLES = `/users/public/all?moduleKey=${MODULO_ALMACEN}`

interface Responsable {
  id: string
  firstName: string | null
  lastName: string | null
}

/**
 * Agrega a quien ya tiene la herramienta si el filtro lo dejó fuera.
 *
 * Hay responsables de antes de esta regla —Carlos Mejía tiene el compresor y
 * solo tiene RH—. Sin esto, al reasignar esa herramienta el select aparecería
 * vacío y la pantalla diría que no la tiene nadie, que es falso. Aparece como
 * valor actual; para volver a elegirlo ya no está, que es justo lo que pide el
 * ticket.
 */
export function conElResponsableActual<T extends Responsable>(
  catalogo: T[],
  actual: { id: string | null | undefined; nombre: string | null | undefined },
): T[] {
  if (!actual.id) return catalogo
  if (catalogo.some((u) => u.id === actual.id)) return catalogo

  // El nombre llega de la ficha de la herramienta, que sí lo trae completo.
  const [firstName = '', ...resto] = (actual.nombre ?? '').trim().split(' ')

  return [
    { id: actual.id, firstName: firstName || 'Responsable', lastName: resto.join(' ') } as T,
    ...catalogo,
  ]
}
